import { useMutation, useQueryClient } from '@tanstack/react-query'
import { MainApi } from 'api/MainApi'
import useMissionStore from 'store/mission'
import { IMission } from 'utils/interfaces'

const useReorderCleaningZones = () => {
  const queryClient = useQueryClient()

  return useMutation<IMission, Error, { fromZoneId: number; toZoneId: number }>({
    mutationFn: ({ fromZoneId, toZoneId }) => {
      useMissionStore.getState().reorderCleaningZone(fromZoneId, toZoneId)
      const zones = useMissionStore.getState().getCleaningZones()
      return MainApi.reorderCleaningZones(
        zones.map((zone, index) => ({
          zone_id: zone.properties.zone_id,
          ordering: index + 1,
        }))
      )
    },
    onSuccess: mission => {
      useMissionStore.getState().setMission(mission)
      queryClient.setQueryData(['mission', mission.mission.id], mission)
      queryClient.invalidateQueries({ queryKey: ['mission', mission.mission.id] })
    },
  })
}

export default useReorderCleaningZones
